import {
  FlowchartAnswer,
  FlowchartState,
  isBooleanTransitions,
  isSingleTransition,
  NodeTransitions,
} from 'features/libra/sections/flowchartSection/flowchartTypes'

/**
 * Processes a flowchart answer and returns the updated state with the next node ID.
 * This is a pure function that can be easily tested without React dependencies.
 *
 * @param currentState - The current flowchart state
 * @param answer - The user's answer to the current question
 * @param transitions - The transitions configuration for the current node
 * @returns An object with the next node ID and updated state, or null if the transition is invalid
 */
export function processFlowchartAnswer(
  currentState: FlowchartState,
  answer: FlowchartAnswer,
  transitions: NodeTransitions
): { nextNodeId: string; updatedState: FlowchartState } | null {
  // Determine next node based on transition type
  let nextNodeId: string | undefined

  if (isBooleanTransitions(transitions)) {
    nextNodeId = answer ? transitions.yes : transitions.no
  } else if (isSingleTransition(transitions)) {
    nextNodeId = transitions.next
  }

  if (!nextNodeId) {
    return null
  }

  // Create updated state with the answer recorded and history updated
  const updatedState: FlowchartState = {
    ...currentState,
    answers: {
      ...currentState.answers,
      [currentState.currentNodeId]: answer,
    },
    history: [...currentState.history, currentState.currentNodeId],
  }

  return { nextNodeId, updatedState }
}
